import React from 'react';
import { createUseStyles } from 'react-jss';
import cx from 'classnames';
import { Theme } from '_lib/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    backgroundColor: '#fff',
    marginBottom: 0,
    border: `2px solid #fff`,
    transition: '0.2s border-color',
  },
  containerHover: {
    cursor: 'pointer',

    '&:hover': {
      borderColor: theme.colors.primary,
    },
  },
  shadow: {
    boxShadow: theme.shadow.level1,
  },
  borderRadius: {
    borderRadius: 6,
  },
}));

type Props = {
  children: React.ReactNode;
  hasShadow?: boolean;
  hasBorderRadius?: boolean;
  onClick?: () => void;
};

const Segment = (props: Props) => {
  const { children, hasShadow = true, hasBorderRadius = true, onClick } = props;
  const classes = useStyles();
  const containerStyle = cx(classes.container, {
    [classes.shadow]: hasShadow,
    [classes.borderRadius]: hasBorderRadius,
    [classes.containerHover]: onClick,
  });

  return (
    <div className={containerStyle} onClick={onClick}>
      {children}
    </div>
  );
};

export default Segment;
